import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faFileAlt, faCreditCard, faStore } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import './VenderAuto.css'; // Archivo CSS separado

export default function VenderAuto() {
    return (
        <div className='vender-auto-section'>
            <div className='vender-auto-container'>
                <h2 className='vender-auto-title'>VENDENOS TU AUTO</h2>

                <div className='vender-auto-benefits'>
                    <div className='benefit-item'>
                        <FontAwesomeIcon icon={faCheckCircle} className='benefit-icon' />
                        <span>Tasación gratuita y sin compromiso.</span>
                    </div>

                    <div className='benefit-item'>
                        <FontAwesomeIcon icon={faFileAlt} className='benefit-icon' />
                        <span>Gestión completa de papeles y trámites.</span>
                    </div>

                    <div className='benefit-item'>
                        <FontAwesomeIcon icon={faCreditCard} className='benefit-icon' />
                        <span>Pago rápido y seguro.</span>
                    </div>

                    <div className='benefit-item'>
                        <FontAwesomeIcon icon={faStore} className='benefit-icon' />
                        <span>Consignación con exposición en salón + web.</span>
                    </div>
                </div>

                <Anchor to="/cotiza" className='vender-auto-btn'>
                    Vender mi auto
                </Anchor>
            </div>
        </div>
    );
}